<template>
    <v-app-bar app dense color="#0273e3" dark v-if="usuario != null">
      <!-- Logo -->
      <v-app-bar-nav-icon @click="toggleDrawer" class="hidden-md-and-up" />
      <v-toolbar-title class="ml-2">Choky</v-toolbar-title>
  
      <!-- Links de navegación para pantallas grandes -->
      <v-spacer />
      <v-btn text class="mx-2 hidden-sm-and-down" v-for="item in navItems" :key="item.title" @click="navigate(item.route)"
      style="letter-spacing: 0;font-weight: 600;font-size: 12px;"
      >
        {{ item.title }}
      </v-btn>
  
      <!-- Opciones de usuario -->
          <v-btn icon text @click="signOut">
            <i class="fas fa-power-off"></i>
          </v-btn>
  
      <!-- Drawer para móvil -->
      <v-navigation-drawer app v-model="drawer" temporary>
        <v-list dense>
          <v-list-item v-for="item in navItems" :key="item.title" @click="navigate(item.route)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-app-bar>
  </template>
  
  <script>
import { mapActions, mapState } from 'vuex';

  export default {
    data() {
      return {
        drawer: false,
        navItems: [
          { title: "Dashboard", route: "/dashboard" },
          { title: "Ventas", route: "/ventas" },
          { title: "Productos", route: "/productos" },
          { title: "Reportes", route: "/reportes" },
        ],
      };
    },
    computed:{
        ...mapState(['usuario'])
    },
    methods: {
        ...mapActions(['signOut']),
      toggleDrawer() {
        this.drawer = !this.drawer;
      },
      navigate(route) {
        this.drawer = false; // Cierra el drawer en móvil
        window.open(route, "_self"); // Cambia según tu lógica de navegación
      },
    },
  };
  </script>
  
  <style>
  .v-toolbar-title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 1.2rem;
  }
  </style>
  